import React from 'react';
import PropTypes from 'prop-types';

const CartBundleLoader = ({ isActive }) => {
	return (
		<div className={`cart-item__loading-spinner ${isActive ? 'active' : ''}`}>
			<div className='d-flex align-items-center justify-content-center w-100 h-100 lds-ring-container'>
				<div className='lds-ring'>
					<div />
					<div />
					<div />
					<div />
				</div>
			</div>
		</div>
	);
};

CartBundleLoader.propTypes = {
	isActive: PropTypes.bool.isRequired,
};

export default CartBundleLoader;
